import { render } from "./ClipBoard.vue?vue&type=template&id=3a46c8f1"
import script from "./ClipBoard.vue?vue&type=script&lang=js"
export * from "./ClipBoard.vue?vue&type=script&lang=js"

import "./ClipBoard.vue?vue&type=style&index=0&id=3a46c8f1&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__